import React, { useRef } from "react";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import SlwocData from "../../data/slwoc.json";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import SlwoContainer from "../../containers/customer-service/Slwo-collateral";

const SlwocPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Sanction Letters (Without Collateral) | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Sanction Letters (Without Collateral)"
                        excerpt=""
                        image="/images/banner/page/company-policies.png"
                    />
                    <SlwoContainer contRef={contRef} data={SlwocData} />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default SlwocPage;
